const styles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageBlock: {
    width: '100%',
    maxWidth: '316px',
    borderRadius: '8px',
    overflow: 'hidden',
    marginBottom: '8px',
    aspectRatio: '80/55',
  },
  image: {
    width: '100%',
    aspectRatio: '1.42',
  },
  name: {
    color: 'kit.text.main',
  },
  companieLogo: {
    marginTop: '12px',
    height: {
      xs: '29px',
      xl: '25px',
    },
  },
  logoImage: {
    height: '100%',
    width: 'auto',
  },
  personalInfoBlock: {
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flexShrink: 0,
  },
  personalInfo: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flexGrow: 1,
  },
  opinion: {
    width: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    fontSize: 14,
    marginBottom: '25px',
    paddingRight: '6px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  links: {
    marginTop: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  socialLink: {
    display: 'flex',
    // marginRight: '17px',
    cursor: 'pointer',
    fontSize: 14,
  },
  social: {
    width: '24px',
    height: '24px',
    mr: 1,
    pointerEvents: 'none',
  },
};

export default styles;
